"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CachedContractsApi = void 0;
exports.isWallet = isWallet;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _chains = require("@blockwell/chains");
var _asyncMutex = require("async-mutex");
function isWallet(data) {
  return data && "wallet" in data && data.wallet;
}
class CachedContractsApi {
  constructor(client, store) {
    (0, _defineProperty2.default)(this, "mutex", new _asyncMutex.Mutex());
    (0, _defineProperty2.default)(this, "fastCache", {});
    this.client = client;
    this.store = store;
  }
  async getAll(queries) {
    if (queries.length === 0) {
      return [];
    }
    let release = await this.mutex.acquire();
    try {
      let {
        instances,
        request
      } = await this.processQueries(queries);
      if (request.length > 0) {
        instances = instances.concat(await this.requestContracts(request));
      }
      let contracts = [];
      for (let q of queries) {
        let query;
        if (typeof q === "string") {
          let split = q.split(/[.\/]/g);
          if (split.length === 2) {
            query = {
              address: split[1],
              chainId: (0, _chains.toChainId)(split[0])
            };
          } else {
            contracts.push(instances.find(it => it.id === q));
            continue;
          }
        } else {
          query = q;
        }
        contracts.push(instances.find(it => (0, _chains.addressEqual)(it.address, query.address) && (0, _chains.chainEqual)(it, query.chainId)));
      }
      return contracts;
    } finally {
      release();
    }
  }
  async getOne(query) {
    if (typeof query === "string") {
      let result = this.fastCache[query];
      if (result) {
        return result;
      }
    }
    let [parsed] = await this.parseQueries([query]);
    if (typeof parsed === "string") {
      var _await$this$store$get;
      let fast = this.fastCache[parsed];
      if (fast) {
        return fast;
      }
      let contract = (_await$this$store$get = await this.store.getItem(parsed)) === null || _await$this$store$get === void 0 ? void 0 : _await$this$store$get.data;
      if (contract) {
        this.fastCache[contract.id] = contract;
        if (typeof query === "string") {
          this.fastCache[query] = contract;
        }
        return contract;
      }
    }
    let result = await this.getAll([query]).then(it => it[0]);
    if (result) {
      this.fastCache[result.id] = result;
      if (typeof query === "string") {
        this.fastCache[query] = result;
      }
    }
    return result;
  }
  async getContract(query) {
    let result = await this.getOne(query);
    if (!result) {
      return null;
    }
    if (isWallet(result)) {
      throw new Error("Result from contract query was a wallet: " + query);
    }
    return result;
  }
  async getContractAbi(query) {
    let contract = await this.getContract(query);
    if (contract !== null && contract !== void 0 && contract.abi) {
      return contract.abi;
    }
    return null;
  }
  async findByAddress(address) {
    let release = await this.mutex.acquire();
    try {
      let cached = await this.store.getItem(address.toLowerCase(), false);

      // Only cache address queries for 30 seconds, since new contracts can be
      // deployed which invalidates the result - unless it's a wallet, in which case it can't be a contract.
      if (!cached || cached.t.getTime() < Date.now() - 30000 && !cached.data.wallet) {
        let found = await this.client.contracts.find(address);
        let wallet = false;
        for (let it of found) {
          await this.store.setItem(it.id, it);
          if ("network" in it) {
            let key = (0, _chains.getChain)(it.network).chainId + "/" + it.address.toLowerCase();
            await this.store.setItem(key, it.id);
          }
          if (isWallet(it)) {
            wallet = true;
          }
        }
        await this.store.setItem(address.toLowerCase(), {
          ids: found.map(it => it.id),
          wallet
        });
        return found;
      }
      return this.getAll(cached.data.ids);
    } finally {
      release();
    }
  }
  async parseQueries(queries) {
    let parsed = [];
    for (let q of queries) {
      let id;
      if (typeof q === "string") {
        if (q.includes("/")) {
          id = q.replace("/", ".");
        } else {
          id = q;
        }
        id = id.toLowerCase();
        if (id.includes(".")) {
          let cachedId = await this.store.getItem(id);
          if (cachedId) {
            id = cachedId.data;
          }
        }
      } else {
        let key = (0, _chains.toChainId)(q.chainId) + "." + q.address.toLowerCase();
        let cachedId = await this.store.getItem(key);
        if (cachedId) {
          id = cachedId.data;
        }
      }
      if (id) {
        parsed.push(id);
      } else {
        parsed.push(q);
      }
    }
    return parsed;
  }
  async processQueries(queries) {
    let instances = [];
    let request = [];
    let parsed = await this.parseQueries(queries);
    for (let q of parsed) {
      let contract;
      if (typeof q === "string") {
        var _await$this$store$get2;
        contract = (_await$this$store$get2 = await this.store.getItem(q)) === null || _await$this$store$get2 === void 0 ? void 0 : _await$this$store$get2.data;
      }
      if (contract) {
        instances.push(contract);
      } else {
        request.push(q);
      }
    }
    return {
      instances,
      request
    };
  }
  async requestContracts(request) {
    let res = await this.client.contracts.query(request);
    let found = res.filter(it => !!it);
    for (let it of found) {
      await this.store.setItem(it.id, it);
      let key = (0, _chains.getChain)(it.network).chainId + "." + it.address.toLowerCase();
      await this.store.setItem(key, it.id);
    }
    return found;
  }
}
exports.CachedContractsApi = CachedContractsApi;
//# sourceMappingURL=CachedContractsApi.js.map